import {Box, Typography as Typo, styled, TypographyProps} from '@mui/material';
import {Dispatch, ReactNode, SetStateAction} from 'react';
import {useFormik} from 'formik';
import {OtpComponent} from '../OtpComponent';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import {NumberComponent} from '../NumberComponent';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import userService from '@jobseeker/common-core/services/user.service';
import {validationSchemaPhoneNumber} from '../../../../helpers/formValidator';
import {AppState} from '@jobseeker/common-core/types';
import {enqueueSnackbar} from 'notistack';

const Typography = styled(Typo)<TypographyProps>(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
}));

interface TwoStepAuthenticationDialogComponentProps {
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
  setTitle: Dispatch<SetStateAction<string>>;
  setSubTitle?: Dispatch<SetStateAction<string>>;
  setDialogContent: Dispatch<SetStateAction<ReactNode>>;
}

export const TwoStepAuthenticationDialogComponent = ({
  setDialogOpen,
  setTitle,
  setSubTitle,
  setDialogContent,
}: TwoStepAuthenticationDialogComponentProps) => {
  const {profile} = useSelector((state: AppState) => state.user);

  const handleEditClick = () => {
    setTitle('Enable 2-Step Verification');
    if (setSubTitle)
      setSubTitle(
        "Each time you login to your iimjobs.com account, you'll need your password and a verification code sent on this number"
      );
    setDialogContent(
      <NumberComponent
        setDialogContent={setDialogContent}
        setDialogOpen={setDialogOpen}
        setTitle={setTitle}
        setSubTitle={setSubTitle}
      />
    );
  };

  const handleContinue = async () => {
    const response = await userService.twoFaEnable();

    if (response.error) {
      enqueueSnackbar(response.error, {variant: 'error'});
      return;
    }

    setTitle('Enable 2-Step Verification');
    if (setSubTitle)
      setSubTitle(
        "Each time you login to your iimjobs.com account, you'll need your password and a verification code sent on this number"
      );
    setDialogContent(
      <OtpComponent isForChangeNumber={false} setDialogOpen={setDialogOpen} />
    );
  };

  return (
    <Box>
      <Box display="flex" mt={1.5}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 400,
            color: 'secondary.main',
          }}
        >
          Confirm your mobile number
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 500,
            color: 'primary.main',
            cursor: 'pointer',
            marginLeft: 1,
          }}
          onClick={() => {
            handleEditClick();
          }}
        >
          (Edit)
        </Typography>
      </Box>
      <Typography variant="subtitle2" fontWeight={600} mt={1.5}>
        {`+${profile.countryCode} ${profile.phone}`}
      </Typography>
      <Box display={'flex'} gap={1.5} mt={3} mb={2}>
        <Button
          onClick={handleContinue}
          disabled={!profile?.phone || !profile.countryCode}
          color="secondary"
          variant="contained"
          sx={{px: 3, py: 1}}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
};
